import {useEffect} from 'react';
import {useProductsStore} from '../store/productsStore';

// Hook موحد للـ products
export function useProducts (options?: { autoFetch?: boolean }) {
  const {
    products,
    brands,
    tags,
    productTypes,
    pagination,
    page,
    loading,
    brandsLoading,
    tagsLoading,
    typesLoading,
    error,
    brandsError,
    tagsError,
    typesError,
    fetchProducts,
    fetchBrands,
    fetchTags,
    fetchProductTypes,
    createProduct,
    updateProduct,
    setPage,
    setPageSize,
    refreshData,
    clearErrors
  } = useProductsStore();

  // Optional auto fetch (opt-in)
  useEffect(() => {
    if (!options?.autoFetch) {return;}
    if (products.length === 0) {fetchProducts();}
    if (brands.length === 0 && !brandsLoading) {fetchBrands();}
    if (tags.length === 0 && !tagsLoading) {fetchTags();}
    if (productTypes.length === 0 && !typesLoading) {fetchProductTypes();}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options?.autoFetch]);

  return {
    // Data
    products,
    brands,
    tags,
    productTypes,
    pagination,
    page,

    // Loading states
    loading,
    brandsLoading,
    tagsLoading,
    typesLoading,

    // Error states
    error,
    brandsError,
    tagsError,
    typesError,

    // Actions
    fetchProducts,
    fetchBrands,
    fetchTags,
    fetchProductTypes,
    createProduct,
    updateProduct,
    setPage,
    setPageSize,
    refreshData,
    clearErrors
  };
}
